var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: { title: "确认收货", width: "90%", footer: null },
      model: {
        value: _vm.openDialog,
        callback: function ($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog",
      },
    },
    [
      _c("div", { staticClass: "a-modal-div1" }, [
        _c(
          "div",
          { staticClass: "dialog-container" },
          [
            _c(
              "a-form",
              { staticClass: "UniformCss", attrs: { "label-width": "80px" } },
              [
                _c(
                  "a-row",
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "订单编号" } },
                          [
                            _c("a-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.order.applyOrderCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "applyOrderCode", $$v)
                                },
                                expression: "order.applyOrderCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "收货日期" } },
                          [
                            _c("a-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.order.receiveTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "receiveTime", $$v)
                                },
                                expression: "order.receiveTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "收货确认人" } },
                          [
                            _c("a-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.order.receiveMan,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "receiveMan", $$v)
                                },
                                expression: "order.receiveMan",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "订单总项数" } },
                          [
                            _c("a-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.order.orderMaterialCount,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "orderMaterialCount", $$v)
                                },
                                expression: "order.orderMaterialCount",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "审批数量" } },
                          [
                            _c("a-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.order.approveNums,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "approveNums", $$v)
                                },
                                expression: "order.approveNums",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "审批总金额" } },
                          [
                            _c("a-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.order.approveTotalSums,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "approveTotalSums", $$v)
                                },
                                expression: "order.approveTotalSums",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", [
          _c(
            "div",
            { staticClass: "logistics-table" },
            [
              _c(
                "h4",
                { staticStyle: { margin: "16px 0", "font-weight": "bold" } },
                [_vm._v("物料信息表")]
              ),
              _c(
                "vxe-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.materialtable,
                    border: "",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "header-cell-style": { background: "#eef1f6" },
                    "select-config": {
                      checkField: "checked",
                      trigger: "row",
                      highlight: true,
                      reserve: true,
                    },
                  },
                },
                [
                  _c("vxe-table-column", {
                    attrs: {
                      field: "materialCode",
                      title: "物料号",
                      width: "200",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "materialName",
                      title: "物料名称",
                      width: "250",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "price",
                      title: "申领价",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "nums",
                      title: "申领数量",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "totalSums",
                      title: "申领总金额",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "approveNums",
                      title: "审批数量",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "approveTotalSums",
                      title: "审批总金额",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "applyRemarks",
                      title: "申领备注",
                      width: "375",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "logistics-table" },
            [
              _c(
                "h4",
                { staticStyle: { margin: "16px 0", "font-weight": "bold" } },
                [_vm._v("物流信息表")]
              ),
              _c(
                "vxe-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.OrderLogistics,
                    border: "",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "header-cell-style": {
                      background: "#eef1f6",
                      fontWeight: "bold",
                    },
                    "row-style": { height: "40px" },
                  },
                  on: { "checkbox-change": _vm.handleSelectionChange },
                },
                [
                  _c("vxe-table-column", {
                    attrs: { type: "checkbox", width: "55", align: "center" },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "trackingNumber",
                      title: "物流单号",
                      width: "650",
                      align: "center",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "status",
                      title: "物流状态",
                      width: "620",
                      align: "center",
                      formatter: function (ref) {
                        var cellValue = ref.cellValue

                        return cellValue === "0" ? "未收货" : "已收货"
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "vxe-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("update:visible", false)
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _c(
              "vxe-button",
              {
                attrs: { status: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("receiveSubmit", _vm.selection)
                  },
                },
              },
              [_vm._v("收货确认")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }